// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { BrandsAndSolutionsModel, getBrandsAndSolutions } from "@guestsupply/App/Services/BrandsAndSolutionsService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<{}, BrandsAndSolutionsModel>;

export const DispatchStartBrandsAndSolutionsLoading: HandlerType = props => {
    props.dispatch({
        type: "xHeaderMenu/StartBrandsAndSolutionsLoading",
    } as any);
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getBrandsAndSolutions();
};
export const DispatchSetBrandsAndSolutionsData: HandlerType = props => {
    props.dispatch({
        type: "xHeaderMenu/SetBrandsAndSolutions",
        brandsAndSolutions: props.apiResult,
    } as any);
    props.dispatch({
        type: "xHeaderMenu/FinishBrandsAndSolutionsLoading",
    } as any);
};

export const chain = [DispatchStartBrandsAndSolutionsLoading, RequestDataFromApi, DispatchSetBrandsAndSolutionsData];

const loadBrandsAndSolutions = createHandlerChainRunner(chain, "loadBrandsAndSolutions");

export default loadBrandsAndSolutions;
